export const CURIOSITY_INTERSTITIAL_QUESTION =
  'Feed your curiosity, 10 minutes a day'
